import Category from './CategoryAndTypeSales';

export default { Category };
